export const PASS_ALREADY_EXISTS = 'PASS_ALREADY_EXISTS';
export const WEB_CHECK_IN_FEATURE_DISABLED = 'WEB_CHECK_IN_FEATURE_DISABLED';
export const SITE_NOT_FOUND = 'SITE_NOT_FOUND';
export const SITE_CHECK_IN_DISABLED = 'SITE_CHECK_IN_DISABLED';
export const IDENTITY_TOKEN_EXPIRED = 'IDENTITY_TOKEN_EXPIRED';
export const INTEGRATION_REQUEST_REJECTED = 'INTEGRATION_REQUEST_REJECTED';
export const CHECK_IN_NOT_PERMITTED = 'CHECK_IN_NOT_PERMITTED';
export const INVITATION_EXPIRED = 'INVITATION_EXPIRED';
export const IDENTITY_CHECK_INVITATION_NOT_ACTIVE_ERROR = 'IDENTITY_CHECK_INVITATION_NOT_ACTIVE_ERROR';
export const INVITATION_NOT_STARTED = 'INVITATION_NOT_STARTED';

export const requestErrorMap: Array<Record<'code' | 'heading' | 'message', string | undefined>> = [
  {
    code: PASS_ALREADY_EXISTS,
    heading: 'Error checking your identity',
    message: 'Pass already found for user',
  },
  {
    code: WEB_CHECK_IN_FEATURE_DISABLED,
    heading: 'Web check-in not enabled',
    message: undefined,
  },
  {
    code: SITE_NOT_FOUND,
    heading: 'Site was not found',
    message: undefined,
  },
  {
    code: SITE_CHECK_IN_DISABLED,
    heading: 'Check-ins at this site are currently deactivated. Contact Sine Support for assistance.',
    message: undefined,
  },
  {
    code: INTEGRATION_REQUEST_REJECTED,
    heading: 'Unable to check you in',
    message: undefined,
  },
  {
    code: CHECK_IN_NOT_PERMITTED,
    heading: `Check-in not permitted`,
    message: 'We were unable to check you in.',
  },
  {
    code: INVITATION_EXPIRED,
    heading: `Invitation expired`,
    message: 'We were unable to check you in.',
  },
  {
    code: INVITATION_NOT_STARTED,
    heading: 'Unable to check in',
    message: 'Invitation not started.',
  },
];
